import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Spin, TreeSelect} from 'antd';
import ApiService from "../../core/service/api-service";
import {useTranslation} from "react-i18next";

// Türkçe arama: "AKCIGER", "akciğer" ve "AKCİĞER" birbirini bulsun.
const normalize = (text) => (text ?? '')
    .toString()
    .toLocaleLowerCase('tr')
    .replace(/[ıî]/g, 'i')
    .replace(/[şŝ]/g, 's')
    .replace(/[ğĝ]/g, 'g')
    .replace(/[üû]/g, 'u')
    .replace(/[öô]/g, 'o')
    .replace(/[çĉ]/g, 'c')
    .replace(/â/g, 'a');

/**
 *
 * @param {{modalityId: number}} props
 */
export default function RequestTypeSelectBox(props)
{
    const {t} = useTranslation();
    const {onOptionsLoaded, modalityId, ...rest} = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Çağıranlar bunu genelde inline arrow olarak veriyor; bağımlılığa koymak her
    // render'da yeniden fetch tetiklerdi.
    const onOptionsLoadedRef = useRef(onOptionsLoaded);
    onOptionsLoadedRef.current = onOptionsLoaded;

    useEffect(() => {
        // Modalite değiştiğinde liste yeniden çekilir. Geç dönen bir yanıt, kullanıcının
        // bu arada seçtiği modalitenin listesini ezmesin diye iptal bayrağı tutuluyor.
        let cancelled = false;

        const getRequestTypeList = async () => {
            setLoading(true);

            const response = modalityId > 0
                ? await ApiService.RequestType.GetByModality(modalityId)
                : await ApiService.RequestType.GetList()

            if(cancelled)
                return;

            setLoading(false);

            if(response.success)
            {
                setData(response.data)
                onOptionsLoadedRef.current?.()
            }
        }

        getRequestTypeList()

        return () => { cancelled = true }
    }, [modalityId])

    const treeData = useMemo(() => data.map(type => ({
        value: type.id,
        title: type.name,
        // İsmin yanında SUT ve LOINC kodları da aranabilsin.
        searchText: normalize([type.name, type.sutCode, type.loincCode].filter(Boolean).join(' '))
    })), [data])

    return (
        <TreeSelect
            showSearch
            style={{width: '100%'}}
            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
            placeholder={t("Please select")}
            allowClear
            treeDefaultExpandAll
            treeData={treeData}
            notFoundContent={loading ? <Spin size={'small'} /> : undefined}
            filterTreeNode={(input, node) => {
                const terms = normalize(input).split(/\s+/).filter(Boolean)
                return terms.every(term => node.searchText.includes(term))
            }}
            {...rest}
        />
    );
}
